import VolumeChallengeScreen from '@/components/TradingChallenge/VolumeChallenge';

export default function TradingChallenge() {
    return (
        <div>
            <VolumeChallengeScreen />
        </div>
    );
}
